(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panel = root.querySelector('#hm-menu-panel');
    const buttons = [...root.querySelectorAll('[data-hm-menu-toggle]')];
    const closeButton = root.querySelector('[data-hm-menu-close]');
    let trigger = null, previousOverflow = '', modal = false;
    const focusables = () => [...panel.querySelectorAll('a,button,input,summary')].filter(el => el.getClientRects().length && !el.disabled);
    function close(restore = true) {
      if (panel.hidden) return;
      panel.hidden = true;
      root.querySelectorAll('.hm-mobile-group').forEach(detail => { detail.open = false; });
      buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (modal) document.body.style.overflow = previousOverflow;
      modal = false;
      if (restore && trigger) trigger.focus();
    }
    function open(button) {
      if (!panel.hidden) { close(); return; }
      root.querySelector('.header__search details[open] summary')?.click();
      trigger = button;
      panel.hidden = false;
      buttons.forEach(toggle => toggle.setAttribute('aria-expanded', 'true'));
      modal = window.matchMedia('(max-width:1100px)').matches;
      panel.setAttribute('aria-modal', String(modal));
      if (modal) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
      closeButton.focus();
    }
    buttons.forEach(button => button.addEventListener('click', () => open(button)));
    closeButton.addEventListener('click', () => close());
    panel.addEventListener('click', event => { if (event.target.closest('a')) close(false); });
    document.addEventListener('click', event => { if (!panel.hidden && !root.contains(event.target)) close(false); });
    root.addEventListener('keydown', event => {
      if (panel.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key === 'Tab') {
        const items = focusables(), first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    root.querySelector('.header__search summary')?.addEventListener('click', () => close(false));
    const dropdowns = [...root.querySelectorAll('.hm-dropdown')];
    function closeDropdowns(except = null) { dropdowns.forEach(detail => { if (detail !== except) detail.open = false; }); }
    dropdowns.forEach(detail => {
      detail.addEventListener('toggle', () => { if (detail.open) { close(false); closeDropdowns(detail); } });
      detail.querySelector('summary').addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); detail.open = true; const links = [...detail.querySelectorAll('a')]; (event.key === 'ArrowUp' ? links[links.length - 1] : links[0])?.focus(); }
      });
    });
    document.addEventListener('click', event => { dropdowns.forEach(detail => { if (!detail.contains(event.target)) detail.open = false; }); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') { const opened = dropdowns.find(detail => detail.open); if (opened) { event.preventDefault(); opened.open = false; opened.querySelector('summary').focus(); } } });
    window.addEventListener('resize', () => { close(false); closeDropdowns(); });
  }
  document.querySelectorAll('[data-hm-header]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hm-header]').forEach(init));
})();
